module.exports = __webpack_public_path__ + "img/american_express.d97d46fe.svg";